<template>
  <div class="app" :class="theme.stylesheet">
    <ModalService />
    <ToastService />
    <OverlayService />
    <ThemeWidget v-if="widget" />
    <GlobalNav>
      <router-view />
    </GlobalNav>
    <CartStack />
    <!-- <img src="https://tools.nxswd.net/track" /> -->
  </div>
</template>

<script>
import CartStack from "@/components/display/CartStack";
import GlobalNav from "@/components/nav/GlobalNav";
import ModalService from "@/components/smart/ModalService";
import OverlayService from "@/components/smart/OverlayService";
// import { onMounted } from "@vue/composition-api";
// import store from "@/store";
import ThemeWidget from "@/components/smart/ThemeWidget";
import ToastService from "@/components/smart/ToastService";
import { useTheme } from "@/utils/index";

export default {
  name: "App",
  components: {
    GlobalNav,
    ModalService,
    OverlayService,
    ThemeWidget,
    ToastService,
    CartStack,
  },
  setup() {
    const { theme, widget } = useTheme();

    // onMounted(() => {
    //   store.dispatch("analytics/loadScript", "gtm");
    // });

    return {
      theme,
      widget,
    };
  },
};
</script>

<style lang="scss" scoped>
.loader-wrapper {
  display: flex;
  height: 100%;
  .loader {
    height: 100%;
    width: 100%;
  }
}
</style>
